import type { ResultsApi } from "@/v2/api/metadata/results";
import type { SportsApi } from "@/v2/api/metadata/sports";
import type { BackofficeContext } from "@/v2/framework/context/types";
import { createAddDialog } from "./add";
import { createDeleteDialog } from "./delete";
import { createEditDialog } from "./edit";

export function createDialogs(options: {
  ctx: BackofficeContext;
  sportsApi: SportsApi;
  resultsApi: ResultsApi;
}) {
  return {
    add: createAddDialog(options),
    delete: createDeleteDialog(options),
    edit: createEditDialog(options),
  };
}
